export const UPDATE_FROM_CITY = 'UPDATE_FROM_CITY';
export const UPDATE_TO_CITY = 'UPDATE_TO_CITY';
export const DELETE_ITEM_FROM_CART = 'DELETE_ITEM_FROM_CART';
export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART';
export const ADD_ITEMS_TO_CART = 'ADD_ITEMS_TO_CART';
export const EMPTY_CART = 'EMPTY_CART';
export const UPDATE_SELECTED_QUOTE = 'UPDATE_SELECTED_QUOTE';
